import { render, staticRenderFns } from "./DrawerRedemptionHistory.vue?vue&type=template&id=0ec94544"
import script from "./DrawerRedemptionHistory.vue?vue&type=script&lang=js"
export * from "./DrawerRedemptionHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports